import React from 'react';
import {Box} from '@mui/material';

/**
 * Compact meter. Fill/track are score-band colors when a percent is present
 * (same red→green as CoverageBar). Empty / unknown coverage shows an unused
 * track, never a fake percent fill.
 */
export default function CoverageSourceMeter({
    pct = null,
    color,
    track,
    height = 6,
}) {
    const fill = pct == null ? 0 : Math.max(0, Math.min(100, Number(pct) || 0));
    // Same floor DualCoverageBars used so a low score is not a hairline.
    const width = fill > 0 ? Math.max(fill, 8) : 0;
    return (
        <Box
            sx={{
                width: '100%',
                height,
                bgcolor: track,
                borderRadius: 1,
                overflow: 'hidden',
            }}
        >
            {width > 0 && (
                <Box
                    sx={{
                        width: `${width}%`,
                        height: '100%',
                        bgcolor: color,
                    }}
                />
            )}
        </Box>
    );
}
